import { AttentionTypeWrapper } from "views/components/AttentionTypeWrapper";
import { CalendarComponent } from "./step2";
import { ConfirmationWrapper } from "views/components/ConfirmationWrapper";
import { Forms } from "../Forms";
import { ReactSVG } from "react-svg";
import { Skeleton, Steps, Typography, notification, Modal } from "antd";
import { Spacer } from "../common/Spacer";
import { Step2 as TimeBlockGroup } from "views/components/TimeBlockTab";
import { WizzardButton } from "views/components/WizzardButton";
import { WizzardWrapper } from "./styles";
import { generateDefaultFormsPayload } from "lib/generateFormsPayload";
import { pathOr } from "ramda";
import { useAuth } from "hooks/useAuth";
import { useHistory } from "react-router";
import { useQuery } from "hooks/useQuery";
import { useRecaptcha } from "hooks/useRecaptcha";
import { useTemporaryUser } from "hooks/useTemporaryUser";
import { useTranslation } from "react-i18next";
import ReCAPTCHA from "react-google-recaptcha";
import React, { useDispatch, useGlobal, useRef, useState } from "reactn";
import config from "config";
import currentStep from "./currentStep.svg";
import moment from "moment-timezone";
import stepIcon from "./step.svg";

const { recaptchaKey } = config;
const { Step } = Steps;
const { Title } = Typography;

export const Wizzard = ({
	bookReservation,
	chosenTimeBlock,
	desktop,
	handleMeet,
	handlerReservation,
	isDniRequired,
	isRutRequired,
	line,
	loading,
	office,
	onSelect,
	setFieldAnswers,
	setIsRutModalVisible,
	setMeetOrFace,
	setReservationPayload,
	temporaryDni,
	temporaryRut,
	user,
	v2,
	wantTemporary,
}) => {
	const { isLoggedIn, isLoggedInTemporary } = useAuth();
	const query = useQuery();
	const history = useHistory();
	const timezone = office && office.timezone;
	const officeSlug = pathOr("", ["slug"], office);
	let officeDirection = pathOr("", ["street"], office);

	const [config] = useGlobal("UIConfig");
	const [isLoading] = useGlobal("isLoading");
	const { t } = useTranslation(["booking"]);

	const { hideReservationBreadCrumb } = config;

	const { name: lineName, slug } = line || {};

	const officeName = pathOr(false, ["name"], office);
	const [current, setCurrent] = useState(0);
	const [values, setValues] = useState(false);
	const refCaptcha = useRef();
	const [selectedDate, setSelectedDate] = useState({
		date: moment(), // to do: timezone this
		from: "",
		to: "",
	});
	const MaxBookeableDays = pathOr(
		180,
		["options", "maxBookableDays"],
		office
	);
	const temporaryQueryParam = query.get("temporary");
	const [forms] = useGlobal("forms");
	const fields = pathOr([], ["fields"], forms);
	const [login, success, loadingTemporary, error] = useTemporaryUser(
		null,
		bookReservation,
		chosenTimeBlock,
		handleMeet
	);

	const { onSubmitWithReCAPTCHA, loading: reCaptchaLoading } = useRecaptcha(
		login,
		refCaptcha
	);
	const handkeSelectTimeBlock = (timeBlock) => {
		onSelect(timeBlock);
		next();
		setSelectedDate({
			...selectedDate,
			from: timeBlock.from,
			to: timeBlock.to,
		});
	};
	const getTimeBlocks = useDispatch("getTimeBlocks");
	const getTimeBlocksV3 = useDispatch("getTimeBlocksV3");
	const attention_type = pathOr(
		false,
		["options", "reservations", "attention_type"],
		office
	);
	const isAllowRervationsV3 = pathOr(
		false,
		["options", "isAllowRervationsV3"],
		office
	);

	const attentionType =
		attention_type === "videocall" || attention_type === "meet"
			? "Videollamada"
			: selectedDate && selectedDate.attentionType !== "videocall"
			? t("faceToFace")
			: t("videoCall");

	const [currentDate, setCurrentDate] = useState(
		moment.tz(new Date(), timezone)
	);
	const selectAttentionType = (val) => {
		if (val) {
			setMeetOrFace(val);
			setSelectedDate({ ...selectedDate, attentionType: val });
		}
		next();
		return;
	};
	const [value, onChange] = useState(new Date());

	const next = () => {
		setCurrent(current + 1);
	};

	const goToModify = (type) => {
		if (attention_type === "videocall" && type === "attention") return;
		if (!attention_type && type === "attention") return;

		if (attention_type === "mixed" && type === "attention") {
			return prev(3);
		}
		if (type === "date") {
			return prev(2);
		}
		if (type === "time") {
			return prev();
		}
	};
	const prev = (prev) => {
		const prevStep = prev || 1;
		setCurrent(current - prevStep);
	};
	const updateSelectedDate = (date) => {
		const parseDate = moment(date);
		setSelectedDate({ ...selectedDate, date: parseDate });
		if (isAllowRervationsV3) {
			getTimeBlocksV3({
				lineSlug: slug,
				officeSlug,
				date: new Date(parseDate),
			});
			return next();
		}
		if (v2) {
			getTimeBlocks({
				lineSlug: slug,
				officeSlug,
				date: new Date(parseDate),
			});
		}
		next();
	};

	const setValuesFun = (data) => {
		setValues(data);
	};

	const handleClickWithoutForms = () => {
		if (isLoggedInTemporary) {
			return handlerReservation(generateDefaultFormsPayload(user));
		}
		if (isRutRequired) {
			return setIsRutModalVisible(true);
		}

		handlerReservation();
	};

	const handleUserFlow = (payload) => {
		const response = handlerReservation(payload);
		if (response && response.error) {
			notification.error({
				message: `Se ha producido un error al intentar crear la reserva`,
				description:
					"La cantidad de respuesta del formulario, no coincide con las preguntas solicitadas",
			});
		}
	};

	const fieldsExist = fields && fields.length > 0;
	const normalSteps = [
		{
			title: "Fecha",
			content: (
				<CalendarComponent
					current={current}
					onChange={onChange}
					value={value}
					lineSlug={slug}
					officeSlug={officeSlug}
					onClick={updateSelectedDate}
					desktop={desktop}
					maxBookableDays={MaxBookeableDays}
					line={line}
					office={office}
				/>
			),
		},
		{
			title: "Hora",
			content: (
				<TimeBlockGroup
					current={current}
					onChange={handkeSelectTimeBlock}
					date={selectedDate.date}
					officeSlug={officeSlug}
					lineSlug={slug}
					v2={v2}
					timezone={timezone}
					desktop={desktop}
					office={office}
					line={line}
				/>
			),
		},
		{
			title: "Confirmación",
			content: (
				<ConfirmationWrapper
					isLoggedIn={isLoggedIn}
					officeName={officeName}
					lineName={lineName}
					officeDirection={officeDirection}
					selectedDate={selectedDate}
					onClick={goToModify}
					attentionType={attentionType}
					desktop={desktop}
					setValuesFun={setValuesFun}
					fieldsExist={fieldsExist}
				/>
			),
		},
	];

	const varSteps = [
		{
			title: "Atención",
			content: (
				<AttentionTypeWrapper
					desktop={desktop}
					current={current}
					onClick={selectAttentionType}
				/>
			),
		},
		{
			title: "Fecha",
			content: (
				<CalendarComponent
					current={current}
					onChange={onChange}
					value={value}
					lineSlug={slug}
					officeSlug={officeSlug}
					onClick={updateSelectedDate}
					desktop={desktop}
					maxBookableDays={MaxBookeableDays}
					line={line}
					office={office}
				/>
			),
		},
		{
			title: "Hora",
			content: (
				<TimeBlockGroup
					current={current}
					onChange={handkeSelectTimeBlock}
					date={selectedDate.date}
					officeSlug={officeSlug}
					lineSlug={slug}
					v2={v2}
					timezone={timezone}
					desktop={desktop}
					office={office}
					line={line}
				/>
			),
		},
		{
			title: "Confirmación",
			content: (
				<ConfirmationWrapper
					isLoggedIn={isLoggedIn}
					officeName={officeName}
					lineName={lineName}
					selectedDate={selectedDate}
					onClick={goToModify}
					attentionType={attentionType}
					desktop={desktop}
					fieldsExist={fieldsExist}
				/>
			),
		},
	];
	const allLoading =
		loading || reCaptchaLoading || loadingTemporary || isLoading;

	const steps =
		attention_type && attention_type === "mixed" ? varSteps : normalSteps;

	const lastStep = current === steps.length - 1;

	if (!office) return <Skeleton />;

	return (
		<WizzardWrapper
			fieldsExist={fieldsExist}
			isLoggedIn={isLoggedIn}
			lastStep={lastStep}
			desktop={desktop}
		>
			{!hideReservationBreadCrumb && (
				<Steps
					current={current}
					direction="horizontal"
					responsive={false}
				>
					{steps.map((item, index) => (
						<Step
							key={item.title}
							icon={
								<>
									<ReactSVG
										src={
											current >= index
												? currentStep
												: stepIcon
										}
									/>

									{desktop && (
										<div
											style={{
												fontSize: 14,
												fontFamily:
													"'Montserrat',sans-serif",
											}}
										>
											{desktop && item.title}
										</div>
									)}
								</>
							}
						/>
					))}
				</Steps>
			)}

			<Spacer rows={1} />
			<div className="line__name-container">{!desktop && lineName}</div>
			<Spacer rows={1} />
			{lastStep && desktop && (
				<div style={{ width: "100%" }}>
					<div className="current-step-label"> {t("lastStep")}</div>
					<Title level={5}>{t("completeData")}</Title>
				</div>
			)}

			<div className="steps-content">
				{steps[current].content}
				{current === steps.length - 1 && !isLoggedIn ? (
					<Forms
						setReservationPayload={setReservationPayload}
						setIsRutModalVisible={setIsRutModalVisible}
						wantTemporary={wantTemporary}
						temporaryRut={temporaryRut}
						temporaryDni={temporaryDni}
						formData={fields}
						handleReservation={handleUserFlow}
						loading={allLoading}
						setFieldAnswers={setFieldAnswers}
						onSubmitWithReCAPTCHA={onSubmitWithReCAPTCHA}
						temporaryQueryParam={temporaryQueryParam}
						chosenTimeBlock={chosenTimeBlock}
						bookReservation={bookReservation}
						handleMeet={handleMeet}
						desktop={desktop}
						officeSlug={officeSlug}
						error={error}
						isLoggedInTemporary={isLoggedInTemporary}
						isRutRequired={isRutRequired}
						isDniRequired={isDniRequired}
					/>
				) : (
					current === steps.length - 1 &&
					isLoggedIn &&
					fields &&
					fields.length > 0 && (
						<Forms
							setReservationPayload={setReservationPayload}
							setIsRutModalVisible={setIsRutModalVisible}
							wantTemporary={wantTemporary}
							formData={fields}
							handleReservation={handleUserFlow}
							loading={allLoading}
							setFieldAnswers={setFieldAnswers}
							onSubmitWithReCAPTCHA={onSubmitWithReCAPTCHA}
							temporaryQueryParam={temporaryQueryParam}
							chosenTimeBlock={chosenTimeBlock}
							bookReservation={bookReservation}
							handleMeet={handleMeet}
							desktop={desktop}
							officeSlug={officeSlug}
							error={error}
							isLoggedInTemporary={isLoggedInTemporary}
							isRutRequired={isRutRequired}
							isDniRequired={isDniRequired}
							temporaryDni={temporaryDni}
						/>
					)
				)}
				{temporaryQueryParam && (
					<ReCAPTCHA
						hl={"es-419"}
						ref={refCaptcha}
						sitekey={recaptchaKey}
						size={"invisible"}
					/>
				)}
				{wantTemporary && (
					<ReCAPTCHA
						hl={"es-419"}
						ref={refCaptcha}
						sitekey={recaptchaKey}
						size={"invisible"}
					/>
				)}
				{isLoggedInTemporary && (
					<ReCAPTCHA
						hl={"es-419"}
						ref={refCaptcha}
						sitekey={recaptchaKey}
						size={"invisible"}
					/>
				)}
			</div>

			<Spacer rows={1} />
			<div className="steps-action">
				{current > 0 && (
					<WizzardButton
						label={t("back")}
						type="backgroundless"
						style={{ margin: "0 8px" }}
						onClick={() => prev()}
					>
						{t("back")}
					</WizzardButton>
				)}

				{current === 0 && (
					<WizzardButton
						label={t("back")}
						type="backgroundless"
						onClick={() => history.goBack()}
					/>
				)}

				{current === steps.length - 1 &&
					isLoggedIn &&
					fields &&
					!fields.length && (
						<WizzardButton
							label={t("completeForm")}
							type="primary"
							onClick={handleClickWithoutForms}
							loading={loading}
							disabled={loading}
						/>
					)}
				{/* {current < steps.length - 1 && (
					<>
						<WizzardButton
							label={"Continuar"}
							type="primary"
							onClick={() => next()}
						/>
					</>
				)} */}

				<Spacer rows={3} />
			</div>
		</WizzardWrapper>
	);
};
